export const VIEW_AFFI         = 15;
export const VIEW_HOLD_CARD    = 16;
export const VIEW_DEPOSIT      = 17;
